import { RepositoryFactory } from "@/js/repository/RepositoryFactory";

const authorityCheckRepository = RepositoryFactory.get("authorityCheck");

const state = {
  data: []
};

const getters = {
  data: state => state.authorityCheck
};

const mutations = {
  setAuthorityCheck(state, authorityCheck) {
    state.authorityCheck = authorityCheck;
  }
};

const actions = {
  async loadAuthorityCheck(context, screenId) {
    const list = await authorityCheckRepository.list(screenId);
    if (list.status < 300) {
      context.commit("setAuthorityCheck", list.data);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
